<template>
    <div class="main-container" id="equipe">
        <!-- blog item wrapper start -->
        <div class="blog-pages-wrapper section-space--ptb_100 border-bottom">
            <div class="container">
              <div class="section-title-wrapper text-center section-space--mb_30">
                <h2 class="section-title font-width-light wow move-up">Équipe</h2>
              </div>
                <div class="row">
                    <div class="col-lg-8">
                        <div class="main-blog-wrap">
                            <!--======= Single Blog Item Start ========-->
                            <div class="single-blog-item">
                                <!-- Post Feature Start -->
                                <div class="post-feature blog-thumbnail  wow move-up picture-pied-pro-rita" style="float: left; padding: 15px;">
                                    <img class="img-fluid"
                                         src="@/assets/img/pied-pro/Dr_Rita_El-Khoury_Podiatre.png"
                                         alt="Blog Images"
                                          width="300"
                                          height="600">
                                </div>
                                <!-- Post Feature End -->

                                <!-- Post info Start -->
                                <div class="post-info lg-blog-post-info  wow move-up">
                                    <h4 class="post-title font-weight--light">
                                        Dre. Rita El-Khoury, podiatre
                                    </h4>
                                    <div class="post-excerpt mt-15">
                                        <p>Dre Rita El-Khoury, podiatre, est détentrice d’un doctorat de premier cycle en
                                          médecine podiatrique de l’Université du Québec à Trois-Rivières depuis 2011.
                                          Elle a également complété un externat au prestigieux New York College of
                                          Podiatric Medicine.
                                        </p>
                                        <p>Elle est membre en règle de l’Ordre des Podiatres du
                                          Québec et titulaire d’un permis de radiologie. Parallèlement à sa pratique, elle a
                                          siégé au Comité de Formation Continue de l’Ordre des Podiatres du Québec de
                                          2015 à 2019 ou elle a eu la chance d’organiser quelques Congrès pour ses
                                          pairs.
                                        </p>
                                        <p>Elle s’est également mérité quelques distinctions honorifiques dont celles
                                          du Choix du Consommateur pour la Podiatrie Rive-Nord pendant 2 années
                                          consécutives.
                                        </p>

                                      <h6>Mission et philosophie</h6>
                                        <p>
                                          Dre Rita El-Khoury, podiatre, s’engage à mettre à profit son expertise pour vous
                                          offrir un service courtois et attentionné de haute qualité qui répond à vos besoins
                                          dans un environnement chaleureux.
                                        </p>

                                        <p>
                                          Elle a l’avantage de travailler en équipe avec les omnipraticiens et d’autres
                                          spécialistes de la clinique médicale en vue d’améliorer les soins offerts aux
                                          patients et de parvenir à un but commun en confrontant des approches
                                          différentes d&#39;un même problème.
                                        </p>

<!--                                        <blockquote >-->
<!--                                            <p class="p1">The role of the designer is that of a good, thoughtful host anticipating the needs of his guests. –Charles Eames</p>-->
<!--                                        </blockquote>-->

                                        <div class="border-bottom">
                                        </div>
                                    </div>
                                </div>
                                <!-- Post info End -->
                            </div>
                            <!--===== Single Blog Item End =========-->
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <SidebarEquipePiedPro />
                    </div>
                </div>
            </div>
        </div>
        <!-- blog item wrapper end -->
    </div>
</template>

<script>
    import SidebarEquipePiedPro from '@/components/pied-pro-custom/SidebarEquipePiedPro'

    export default {
        name: 'EquipePiedPro',
        components: {
          SidebarEquipePiedPro
        }
    }
</script>
